import { API_URL } from "../constants/api.constants";
import { AppEnvVariables } from "../constants/environment.constants";
import { kf1AuthenticatedHttpClient} from "kfone-frontend-core";

const clientsSearch = async () => {
  //  when npvn is ready, we will use the below line

  const clientsSearchUrl = AppEnvVariables.API_DOMAIN + API_URL.CLIENTS;
  const headers = { "Content-Type": "text/plain" };
  const config: any = {
    method: "GET",
    url: clientsSearchUrl,
    headers: headers
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res.data;
};

export { clientsSearch };
